import { useNavigate, useLocation } from "react-router-dom";
import UserInfoHeader from "../../components/layout/UserInfoHeader";
import AppsIcon from "../../components/AppsIcon/AppsIcon";
import "./Header.css";

/**
 * Header Component
 * Updated for Auth Microservice integration - v2.0
 */
const Header = ({ showHideSideBar }) => {
    let navigate = useNavigate();
    let location = useLocation().pathname.substring(1);

    let getTitle = () => {
        if (location.startsWith("view-ticket")) {
            return "Ticket Details";
        } else if (location === "") {
            return "Dashboard";
        } else if (location === "tickets") {
            return "All Tickets";
        } else if (location === "my-tickets") {
            return "My Tickets";
        } else if (location === "add-new-ticket") {
            return "Create New Ticket";
        } else if (location === "analytics") {
            return "Analytics";
        } else if (location === "apps") {
            return "Applications";
        }
        return "CRM Ticket System";
    };

    return (
        <div className="header">
            <div className="left">
                {/* <div className="menu" onClick={showHideSideBar}>
                    <i className="las la-bars" />
                </div> */}
                
                <div className="title">{getTitle()}</div>
            </div>
            <div className="right">
                <div
                    className="add-ticket"
                    onClick={() => {
                        navigate("/add-new-ticket");
                    }}
                >
                    <span className="content">New Ticket</span>
                    <i className="las la-plus" />
                </div>
                
                {/* Apps Icon */}
                <AppsIcon />
                
                {/* User Info with Dropdown */}
                <UserInfoHeader />
            </div>
        </div>
    );
};

export default Header;
